@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.Badge {
  @extend %font-family-primary;

  padding: 4px 6px;
  background-color: $theme-badge-default-color;
  border: 0;
  border-radius: 6px;
  font-size: $font-size-normal;
  font-weight: $font-weight-semibold;
  line-height: 18px;
  color: $theme-color-text;
}

button.Badge {
  cursor: pointer;

  &:hover {
    background-color: $theme-badge-hover-color;
  }

  &:active {
    background-color: $theme-badge-active-color;
  }

  &:focus {
    background-color: $theme-badge-active-color;
  }
}

.PopOut {
  @extend %font-family-primary;

  max-width: 288px;
  padding: 16px;
  border-radius: 8px;
  line-height: 18px;
}
